import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Form,
    Modal,
    Select,
    Input,
    InputNumber
} from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import {changeServerStatus, createServerInfoAction, getHostList, submitServerInfo} from './actions';
const FormItem = Form.Item;

class ServerInfo extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
    }
    changeAddHide = () => {
        this.props.changeServerStatus({showServe: false});
        this.reset();
    };
    reset = () => {
        this.props.createServerInfoAction({}); // 信息重置
        this.props.form.resetFields();
    };
    async submit() {
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                try {
                    const { serverInfo: { partnerList } } = this.props;
                    let resultData = {
                        partnerList,
                        ...fieldsValue,
                    };
                    // 数据提交
                    await this.props.submitServerInfo(resultData);
                    this.changeAddHide();
                    await this.props.GetHostList();
                } catch (err) {
                    console.log(err);
                    alert(err);
                }
            } else {
                console.log(err);
            }
        });
    };
    render() {
        const { getFieldDecorator } = this.props.form;
        const { serverInfo = {}, serverStatus } = this.props;
        const formItemLayout = {
            labelCol: {
                xs: { span: 18 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 18 },
                sm: { span: 14 },
            },
        };

        const partnerListOption = serverInfo.partnerList && serverInfo.partnerList.map(item => <Option key={item.name}>{item.name}</Option>);
        return (
            <div>
                <Modal
                    title='修改'
                    visible={serverStatus.showServe}
                    onCancel={() => this.changeAddHide()}
                    onOk={this.submit}>
                    <Form>
                        <FormItem {...formItemLayout} label="http服务地址">
                            {getFieldDecorator('serverHostIp', {
                                initialValue: serverInfo.serverHostIp,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入http服务地址,例如172.0.0.1',
                                        pattern: /^\d{1,3}.\d{1,3}.\d{1,3}.\d{1,3}$/,
                                    },
                                ],
                            })(<Input placeholder="请输入ip地址"/>)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="http服务端口">
                            {getFieldDecorator('serverPort', {
                                initialValue: serverInfo.serverPort,
                            })(<Input placeholder="请填入http服务端口" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="集群名称">
                            {getFieldDecorator('cluster', {
                                initialValue: serverInfo.cluster,
                            })(<Input placeholder="请填入集群名称" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="server IP">
                            {getFieldDecorator('hostIp', {
                                initialValue: serverInfo.hostIp,
                            })(<Input placeholder="请填入server IP" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="代理商">
                            {getFieldDecorator('partners', {
                                initialValue: serverInfo.partners,
                            })(
                                <Select style={{ width: '100%' }} placeholder="请选择代理商" mode="tags">
                                    {partnerListOption}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="调度服务端口">
                            {getFieldDecorator('port', {
                                initialValue: serverInfo.port,
                            })(<Input placeholder="请填入调度服务端口" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="zookeeper配置地址">
                            {getFieldDecorator('serverMonitorPath', {
                                initialValue: serverInfo.serverMonitorPath,
                            })(<Input placeholder="请填入zookeeper配置地址" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="任务阻塞阈值">
                            {getFieldDecorator('taskThreshold', {
                                initialValue: serverInfo.taskThreshold,
                            })(<Input placeholder="请填入任务阻塞阈值" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="点击总阻塞阈值">
                            {getFieldDecorator('totalClickThreshold', {
                                initialValue: serverInfo.totalClickThreshold,
                            })(<Input placeholder="请填入总阻塞阈值" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="曝光总阻塞阈值">
                            {getFieldDecorator('totalEvThreshold', {
                                initialValue: serverInfo.totalEvThreshold,
                            })(<Input placeholder="请填入总阻塞阈值" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="zookeeper地址">
                            {getFieldDecorator('workersPath', {
                                initialValue: serverInfo.workersPath,
                            })(<Input placeholder="请填入zookeeper地址" />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="点击队列桶大小">
                            {getFieldDecorator('clickBucketSize', {
                                initialValue: serverInfo.clickBucketSize,
                            })(<InputNumber style={{ width: '100%' }} placeholder="请填入点击队列桶大小" />)}
                        </FormItem>
                    </Form>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    serverStatus: state.hostList.serverStatus,
    serverInfo: state.hostList.serverInfo,
});

const mapDispatchToProps = dispatch => ({
    GetHostList: prarms => dispatch(getHostList()),
    changeServerStatus: prarms => dispatch(changeServerStatus(prarms)),
    createServerInfoAction: prarms => dispatch(createServerInfoAction(prarms)),
    submitServerInfo: params => dispatch(submitServerInfo(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(ServerInfo));



// WEBPACK FOOTER //
// ./pages/assist/hostManage/serverInfo.js